import { Link } from "react-router-dom";
import type { Chapter } from "@/types/comic";

interface ChapterListProps {
  comicId: string;
  chapters: Chapter[];
}

export default function ChapterList({ comicId, chapters }: ChapterListProps) {
  const list = [...chapters].reverse();

  return (
    <section className="mt-8">
      <div className="flex items-center justify-between gap-3 mb-5 flex-wrap">
        <h2 className="font-heading font-bold text-lg md:text-xl text-foreground-950 flex items-center gap-2">
          <span className="w-9 h-9 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center">
            <i className="ri-list-ordered text-xl"></i>
          </span>
          章节目录
        </h2>
        <span className="text-sm text-foreground-500">共 {chapters.length} 话 · 按最新排序</span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2.5">
        {list.map((chapter, idx) => (
          <Link
            key={chapter.id}
            to={`/read/${comicId}/${chapter.id}`}
            className="group flex items-center justify-between gap-3 px-4 py-3 rounded-md bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50 transition-colors cursor-pointer"
          >
            <span className="flex items-center gap-2 min-w-0">
              <span
                className={`w-6 h-6 rounded text-[11px] flex items-center justify-center shrink-0 ${
                  idx === 0
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-500"
                }`}
              >
                {idx === 0 ? "新" : list.length - idx}
              </span>
              <span className="text-sm text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                {chapter.title}
              </span>
            </span>
            <span className="text-xs text-foreground-400 shrink-0 whitespace-nowrap">
              {chapter.updateTime}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}